import React from "react";
import { Link } from "react-router-dom";
import {
  FaHandshake, FaBus, FaArrowRight, FaCheck,
  FaShieldAlt, FaClock, FaStar, FaUsers,
} from "react-icons/fa";

const SERVICES = [
  {
    to: "/meet-and-greet-parking",
    icon: <FaHandshake className="text-3xl" />,
    tag: "Most Popular",
    tagBg: "bg-secondary text-primary",
    title: "Meet & Greet",
    subtitle: "Premium Convenience",
    desc: "Drive directly to your terminal and hand your keys to a professional driver. The ultimate in convenience — perfect for families, business travellers, or anyone seeking VIP service.",
    points: [
      "Terminal drop-off & collection",
      "Professional insured drivers",
      "Secure off-site storage",
      "Time-saving & hassle-free",
    ],
    cardBg: "bg-primary",
    iconBg: "bg-secondary",
    iconColor: "text-primary",
    btnBg: "bg-secondary text-primary hover:bg-white",
    stat: { icon: <FaStar />, text: "4.8★ Rated" },
  },
  {
    to: "/park-and-ride-parking",
    icon: <FaBus className="text-3xl" />,
    tag: "Best Value",
    tagBg: "bg-secondary text-primary",
    title: "Park & Ride",
    subtitle: "Budget Friendly",
    desc: "Park your car in a secure facility near the airport and take a complimentary shuttle to your terminal. The smart choice for budget-conscious travellers.",
    points: [
      "Most cost-effective option",
      "Secure CCTV-monitored facilities",
      "Frequent shuttle transfers",
      "Perfect for all trip lengths",
    ],
    cardBg: "bg-lightprimary",
    iconBg: "bg-secondary",
    iconColor: "text-primary",
    btnBg: "bg-secondary text-primary hover:bg-white",
    stat: { icon: <FaUsers />, text: "1000s Booked" },
  },
];

const ParkingServicesSection = () => {
  return (
    <section className="py-10 md:py-14 bg-white">
      <div className="px-4 mx-auto max-w-[1280px]">

        {/* Heading */}
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 mb-3 text-xs font-bold uppercase rounded-full bg-secondary text-primary">
            Our Services
          </span>
          <h2 className="text-2xl font-bold md:text-3xl text-primary">
            Explore Our <span className="text-lightprimary">Parking Services</span>
          </h2>
          <p className="max-w-xl mx-auto mt-2 text-sm text-primary/70">
            Choose the perfect parking solution that fits your budget and travel needs
          </p>
        </div>

        {/* Cards */}
        <div className="grid gap-5 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <Link
              key={i}
              to={s.to}
              className={`relative flex flex-col overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 ${s.cardBg} text-white group`}
            >
              {/* Top bar */}
              <div className="h-1 w-full bg-secondary" />

              <div className="flex flex-col flex-1 p-6">
                {/* Header row */}
                <div className="flex items-start justify-between mb-5">
                  <div className="flex items-center gap-4">
                    <div className={`flex items-center justify-center w-14 h-14 rounded-xl ${s.iconBg} ${s.iconColor} shadow-md flex-shrink-0`}>
                      {s.icon}
                    </div>
                    <div>
                      <h3 className="text-xl font-bold">{s.title}</h3>
                      <p className="text-sm opacity-80">{s.subtitle}</p>
                    </div>
                  </div>
                  <span className={`text-xs font-bold px-3 py-1 rounded-full flex-shrink-0 ${s.tagBg}`}>
                    {s.tag}
                  </span>
                </div>

                {/* Desc */}
                <p className="mb-5 text-sm leading-relaxed opacity-90">{s.desc}</p>

                {/* Points */}
                <ul className="mb-6 space-y-2">
                  {s.points.map((pt, j) => (
                    <li key={j} className="flex items-center gap-3 text-sm">
                      <span className="flex-shrink-0 w-5 h-5 rounded-full bg-secondary flex items-center justify-center">
                        <FaCheck className="text-[9px] text-primary" />
                      </span>
                      <span className="opacity-90">{pt}</span>
                    </li>
                  ))}
                </ul>

                {/* Footer row */}
                <div className="flex items-center justify-between mt-auto">
                  <span className="flex items-center gap-2 text-xs font-bold text-secondary">
                    {s.stat.icon} {s.stat.text}
                  </span>
                  <span className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-bold transition-colors duration-300 ${s.btnBg}`}>
                    Learn More <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </div>

              {/* Decorative circle */}
              <div className="absolute w-36 h-36 rounded-full -bottom-10 -right-10 bg-white/5 pointer-events-none" />
            </Link>
          ))}
        </div>

        {/* Bottom trust strip */}
        <div className="grid grid-cols-2 gap-3 mt-6 sm:grid-cols-4">
          {[
            { icon: <FaShieldAlt />, text: "Fully Insured" },
            { icon: <FaClock />, text: "24/7 Available" },
            { icon: <FaStar />, text: "Top Rated" },
            { icon: <FaUsers />, text: "1000s Served" },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-3 p-3 rounded-xl bg-primary/5 border border-primary/10">
              <span className="text-lg text-lightprimary flex-shrink-0">{item.icon}</span>
              <span className="text-xs font-bold text-primary">{item.text}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ParkingServicesSection;
